// src/Pages/Photography/PostApocalypticHighFashion.jsx
import * as React from "react";
import { ThemeProvider, createTheme, Typography, Box, Grid, Button, Modal } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import pic10 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-24.jpg";
import pic11 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-25.jpg";
import pic12 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-26.jpg";
import pic13 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-27.jpg";
import pic14 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-28.jpg";
import pic16 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-30.jpg";
import pic17 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-31.jpg";
import pic18 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-79.jpg";
import pic19 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-80.jpg";
import pic20 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-81.jpg";
import pic21 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-82.jpg";
import pic22 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-83.jpg";
import pic23 from "./photography/fashion/post-apocalyptic high fashion/leonidpesenti-84.jpg";

import Footer from "../Footer";

export default function PostApocalypticHighFashion() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: {
        fontSize: "3rem",
        fontWeight: 200,
        wordBreak: "break-word",
        overflowWrap: "anywhere",
      },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: { fontSize: "1.25rem", fontWeight: 300 },
      },
    },
  });

  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const tablet = useMediaQuery("(min-width:768px) and (max-width:1000px)");
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const images = [pic14, pic16, pic10, pic23, pic13, pic19, pic17, pic18];

  const [open, setOpen] = React.useState(false);
  const [modalSrc, setModalSrc] = React.useState(null);

  const handleOpen = (src) => { setModalSrc(src); setOpen(true); };
  const handleClose = () => setOpen(false);

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        minHeight="100vh"
        marginTop="5vh"
        maxWidth="100vw"
        pb="10vh" // breathing space above fixed footer
      >
        {/* Title constrained to text box width */}
        <Box sx={{ width: "80vw", maxWidth: 1200, mb: "5vh" }}>
          <Typography
            variant="h1"
            component={require("react-router-dom").Link}
            to="/ph"
            sx={{
              display: "block",
              textAlign: "center",
              color: "inherit",
              textDecoration: "none",
              cursor: "pointer",
              width: "100%",
            }}
          >
            // post-apocalyptic high fashion
          </Typography>
        </Box>

        {/* Caption */}
        <Box sx={{ width: "60vw", maxWidth: 1200, mb: "5vh" }}>
          <Typography variant="body1" sx={{ textAlign: "left" }}>
            <a target="_blank" rel="noreferrer" href="/pahf_EN.pdf">english</a>&nbsp;and&nbsp;
            <a target="_blank" rel="noreferrer" href="/pahf_IT.pdf">italian</a>&nbsp;versions of the project that was exhibited at&nbsp;
            <a target="_blank" rel="noreferrer" href="https://www.gallerialaloggia.ch">Galleria La Loggia</a>
            <br /><br />
            Calcareous slopes which display a desolated landscape, that offer nothing but dead trees and traces of an ancient village,
            encased by tall mountains in the process of losing their snowy tops to the approach of warmer seasons. What are the values of beauty and fashion in a dead world?
            <br /><br />
            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/p/CiTKJFiq_UR/">some pictures from the gallery</a>
            <br /><br />
            <span style={{ marginLeft: "2rem" }}>// styling:</span> <a target="_blank" rel="noreferrer" href="https://www.instagram.com/cielo_solari/">Cielo Solari</a><br />
            <span style={{ marginLeft: "2rem" }}>// models:</span> <a target="_blank" rel="noreferrer" href="https://www.instagram.com/nassiali_/">Nassi</a> /
            <a target="_blank" rel="noreferrer" href="https://www.instagram.com/zoecaminada/">Zoe</a>
          </Typography>
        </Box>

        {/* Image grid (left-aligned) */}
        <Grid
          container
          spacing={2}
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ width: "80vw", maxWidth: 1200 }}
        >
          {images.map((src, i) => {
            if (tablet) {
              return (
                <Grid key={i} item xs={6}>
                  <img src={src} alt={`PAHF ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                </Grid>
              );
            } else if (sm) {
              return (
                <Grid key={i} item xs={12}>
                  <img src={src} alt={`PAHF ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                </Grid>
              );
            } else {
              return (
                <Grid key={i} item xs={3}>
                  {isDesktop ? (
                    <Button onClick={() => handleOpen(src)} sx={{ p: 0, minWidth: 0, lineHeight: 0, cursor: "zoom-in" }}>
                      <img src={src} alt={`PAHF ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                    </Button>
                  ) : (
                    <img src={src} alt={`PAHF ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                  )}
                </Grid>
              );
            }
          })}
        </Grid>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 0,
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "80vh",
            display: "flex",
          }}
        >
          {modalSrc && (
            <img
              src={modalSrc}
              alt="Preview"
              style={{ maxWidth: "90vw", maxHeight: "80vh", width: "auto", height: "auto" }}
            />
          )}
        </Box>
      </Modal>

      <Footer fixed />
    </ThemeProvider>
  );
}
